export const errorType = Object.freeze({
  default: 'ERROR_UNKNOWN',
  noCache: 'ERROR_NO_CACHE',
});

export const errorMessage = Object.freeze({
  default: 'Oops...something went wrong.',
  noCache: 'Not using cached response',
});
